import qs from "qs";
import { useSdkContext } from "~/components/contexts";
export const useSocialLogin = () => {
  const {
    config
  } = useSdkContext();
  const getSocialLoginUrl = (socialType, parameters, isAgreed) => {
    const accountUrl = new URL(config.accounts.host);
    const destinationUrl = new URL(location.href);
    destinationUrl.search = qs.stringify(parameters); // Use qs at here for better parsing in app side

    const {
      triggerPoint,
      ...restParameters
    } = parameters;
    const signinUrl = new URL(location.href);
    signinUrl.search = qs.stringify(restParameters);
    accountUrl.searchParams.set("callback", signinUrl.toString());
    accountUrl.searchParams.set("destination", destinationUrl.toString());
    accountUrl.searchParams.set("nonce", "");
    accountUrl.searchParams.set("optIn", isAgreed ? "true" : "false");
    accountUrl.searchParams.set("triggerPoint", triggerPoint);
    accountUrl.pathname = `/login/${socialType}`;
    return accountUrl.toString();
  };
  return {
    getSocialLoginUrl
  };
};